export default __webpack_public_path__ + "static/media/herogi-logo.0b305b93.svg";